import actionTypes from "./actionTypes";

export const getBrands = (appKeys) => ({
  type: actionTypes.GET_BRAND_START,
  payload: appKeys,
});

export const getProductGroups = (appKeys) => ({
  type: actionTypes.GET_PRODUCT_GROUP_START,
  payload: appKeys,
});

export const getProductCategories = (appKeys) => ({
  type: actionTypes.GET_PRODUCT_CATEGORY_START,
  payload: appKeys,
});

export const getSuppliers = (appKeys) => ({
  type: actionTypes.GET_SUPPLIER_START,
  payload: appKeys,
});

export const getCustomers = (appKeys) => ({
  type: actionTypes.GET_CUSTOMERS_START,
  payload: appKeys,
});

export const getCurrencies = (appKeys) => ({
  type: actionTypes.GET_CURRENCY_START,
  payload: appKeys,
});
